import React, { useState, useEffect } from 'react';
import {Modal, FormControl, Box, Tooltip, Typography, Snackbar, Alert,TextField, 
  Select,MenuItem,ListItemText,FormHelperText,ToggleButton,ToggleButtonGroup,
  Button, Checkbox, FormControlLabel, FormGroup, IconButton,CircularProgress 
} from '@mui/material';
import EditIcon from '@mui/icons-material/EditOutlined';
import { grey, red,blue } from '@mui/material/colors';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import BASE_URL from '../../config'

const style = {
  position: 'absolute', 
  top: '50%', 
  left: '50%', 
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white', 
  borderRadius: 4, 
  px: 4,
  py: 3, 
  outline: 'none', 
  width: { xs: '90%', sm: '500px' }, 
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'auto', 
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  // Ocultar para Firefox
  scrollbarWidth: 'none',
  // Ocultar para Internet Explorer y Edge antiguo
  msOverflowStyle: 'none',
};

const Inputstyle = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#f5f5f5',
    borderRadius: '8px',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: grey[400] },
    '&.Mui-focused fieldset': { borderColor: grey[600] },
    '&.Mui-error fieldset': { borderColor: red[700] },
  },
};

export default function EditarAgenda ({ agenda, refresh }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ fecha_inicio:null,fecha_fin:null,
    hora_entrada:null,hora_salida:null,
    cliente: '',encargado:'',
    notas:'-',agentes:[],estado:'',prioridad:'' });
  const [confirmType, setConfirmType] = useState(null); 
  const [errors, setErrors] = useState(false);
  const [catalogos, setCatalogos] = useState({ clientes: [], usuarios: [] });
  const [loading, setLoading] = useState(false);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  
  useEffect(() => {
    const fetchCatalogos = async () => {
      try {
        const res = await fetch(`${BASE_URL}/agendas/getdata`);
        const data = await res.json();
        if (data.success) setCatalogos({ clientes: data.clientes, usuarios: data.usuarios });
      } catch (err) {
        console.error("Error cargando catálogos", err);
      }
    };
    if (open) fetchCatalogos();
  }, [open]);

  useEffect(() => {
    if (agenda && open) {
      setForm({
        cliente: agenda.cliente_id ||'',
        encargado: agenda.usuario_id || '',
        fecha_inicio: agenda.fecha_inicio ? dayjs(agenda.fecha_inicio) : null,
        fecha_fin: agenda.fecha_fin ? dayjs(agenda.fecha_fin) : null,
        hora_entrada: agenda.hora_entrada ? dayjs(agenda.hora_entrada, 'HH:mm') : null,
        hora_salida: agenda.hora_salida ? dayjs(agenda.hora_salida, 'HH:mm') : null,
        agentes: agenda.lista_agentes_ids || [],
        notas: agenda.notas || '',
        estado: agenda.estado || '',
        prioridad:agenda.prioridad || '',
      });
    }
  }, [agenda, open]);

  const handleCheck = (p) => {
    const nuevos = form.agentes.includes(p)
      ? form.agentes.filter(item => item !== p)
      : [...form.agentes, p];
    setForm({ ...form, agentes: nuevos });

  };

  const validate = () => {
    let newErrors = {};
    if (!form.cliente) newErrors.cliente = "Seleccione un cliente";
    if (!form.encargado) newErrors.encargado = "Seleccione un encargado";
    if (!form.fecha_inicio) newErrors.fecha_inicio = "Requerido";
    
    // Validación lógica de fechas
    if (form.fecha_inicio && form.fecha_fin) {
      if (form.fecha_fin.isBefore(form.fecha_inicio, 'day')) {
        newErrors.fecha_fin = "La fecha fin no puede ser anterior al inicio";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveClick = () => {
    if (validate()) setConfirmType('save');
  };

  const handleUpdate = async () => {
    setLoading(true);
    setErrors('');
    try {
      const payload = {
        usuario_id: parseInt(form.encargado, 10),
        cliente_id: parseInt(form.cliente, 10),
        fecha_inicio: form.fecha_inicio?.format('YYYY-MM-DD'),
        fecha_fin: form.fecha_fin?.format('YYYY-MM-DD'),
        hora_entrada: form.hora_entrada?.format('HH:mm'),
        hora_salida: form.hora_salida?.format('HH:mm'),
        estado: form.estado,
        prioridad: form.prioridad,
        notas: form.notas,
        agentesIds: form.agentes // Ya son IDs por el handleCheck
      };
      const res = await fetch(`${BASE_URL}/agendas/${agenda.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setSnackbar({ open: true, message: 'Ajustes realizados con éxito', severity: 'success' });
        setTimeout(() => {
          if(refresh) refresh(); setOpen(false); setConfirmType(null);
        }, 1500); 
      } else {
        const data = await res.json();
        setErrors(data.message || 'Error al registrar la cita.');
        setConfirmType(null); 
      }
    } catch (e) {
      setErrors('Error de conexión con el servidor.');
    } finally {
      setLoading(false);
    }
  }

  const boxstyle = { 
  mx:0.3, 
  my:0.3,  
  maxHeight: '60px',
  overflowY: 'auto', 
  bgcolor: '#ffffff',

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: grey[300],
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: grey[500],
  },
  }

  const ConfirmView = () => (
    <Box sx={style}>
      <Typography variant="h6">
        {confirmType === 'cancel' ? '¿Cancelar edición?' : '¿Guardar cambios?'}
      </Typography>
      <Typography variant="body1" color='textSecondary' sx={{ mt: 1, mb: 3 }}>
        {confirmType === 'cancel' 
          ? '¿Estás seguro que deseas cancelar? Los cambios realizados se perderán.' 
          : '¿Estás seguro que deseas aplicar los cambios a este cliente?'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'end' }}>
        <Button 
          variant="contained" 
          sx={{ bgcolor: grey[200], color: 'black', textTransform: 'none', px: 3}} 
          onClick={() => setConfirmType(null)}
        >
          {confirmType === 'cancel' ? 'No, continuar' : 'No, revisar'}
        </Button>
        <Button 
          variant="contained" 
          sx={{ bgcolor: 'black', color: 'white', textTransform: 'none', px: 3}}
          onClick={confirmType === 'cancel' ? () => setOpen(false) : handleUpdate}
        >
          {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> :confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar'}
        </Button>
      </Box>
    </Box>
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <IconButton onClick={() => setOpen(true)} 
      sx={{'&:hover': {color:grey[100], bgcolor: blue[400] } }}>
        <EditIcon fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={() => setConfirmType('cancel')}>
        <Box>
          {confirmType ? <ConfirmView /> : (
            <Box sx={style}>
                  {/* TITULOS */}
                <Box sx={{ mb: 1, display:'flex', justifyContent:'start', alignItems:'center', gap:2}}>
                  <Typography variant="h6">Editar Cita</Typography>
                  <Typography variant="subtitle1" color='textSecondary'>Actualiza la información de la cita</Typography>
                </Box>

                  {/* FORMULARIO */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                  {/* FECHAS Y HORAS */}
                  <FormControl>
                    <Typography sx={{ mb: 1.5 }}>Fecha</Typography>
                    <Box sx={{display: 'flex', gap:2, alignItems:'center' }}>
                      <DatePicker
                        sx={{width:'auto'}}
                        label="Inicio"
                        value={form.fecha_inicio}
                        onChange={(val) => setForm({...form, fecha_inicio: val})}
                        slotProps={{ 
                          textField: { 
                            size: 'small', sx: Inputstyle, error: !!errors.fecha_inicio,helperText: errors.fecha_inicio 
                          } 
                          }
                        }
                      /> - 
                      <DatePicker
                        sx={{width:'auto'}}
                        label="Fin"
                        value={form.fecha_fin}
                        onChange={(val) => setForm({...form, fecha_fin: val})}
                        slotProps={{ 
                            textField: { 
                              size: 'small', sx: Inputstyle, error: !!errors.fecha_inicio,helperText: errors.fecha_inicio
                            } 
                        }}
                      />
                    </Box>
                    <FormGroup sx={{mt:3,display:'flex', flexDirection:'row', justifyContent:'space-between',alignItems:'center'}}>
                      <MobileTimePicker 
                      sx={{width:'45%'}} 
                      label="Inicio" 
                      slotProps={{textField:{size:"small"}}}
                      value={form.hora_entrada}
                      onChange={(val) => setForm({...form, hora_entrada: val})}
                      /> - 
                      <MobileTimePicker 
                      label="Fin" 
                      slotProps={{textField:{size:"small"}}}
                      value={form.hora_salida}
                      onChange={(val) => setForm({...form, hora_salida: val})}
                      sx={{width:'45%'}}
                        />
                    </FormGroup>
                  </FormControl>

                  {/* CLIENTES */}
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Clientes</Typography>
                    <Select 
                      name="cliente" 
                      size='small' 
                      displayEmpty 
                      value={form.cliente} 
                      onChange={(e) => setForm({ ...form, cliente: e.target.value })}
                      sx={Inputstyle} 
                      fullWidth>
                      <MenuItem disabled value="">Seleccionar Cliente</MenuItem>
                      {catalogos.clientes.map((c) => (<MenuItem key={c.id} value={c.id}><ListItemText primary={c.empresa} /></MenuItem>))}
                    </Select>
                    { errors && form.cliente === '' && <FormHelperText sx={{ color: red[700] }}>Campo requerido</FormHelperText>}
                  </FormControl>

                  {/* ENCARGADO */}
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Encargado</Typography>
                    <Select 
                      name="encargado" 
                      size='small' 
                      displayEmpty 
                      value={form.encargado} 
                      onChange={(e) => setForm({ ...form, encargado: e.target.value })}
                      sx={Inputstyle} 
                      fullWidth>
                      <MenuItem disabled value="">Seleccionar Encargado</MenuItem>
                      {catalogos.usuarios.map((u) => (<MenuItem key={u.id} value={u.id}><ListItemText primary={u.nombre_completo} /></MenuItem>))}
                    </Select>
                    { errors && form.encargado === '' && <FormHelperText sx={{ color: red[700] }}>Campo requerido</FormHelperText>}
                  </FormControl>

                  {/* AGENTES */}
                    <FormGroup>
                      <Typography sx={{ mb: 0.5 }}>Agentes</Typography>
                      <Tooltip 
                        title="Debes seleccionar al menos un agente" 
                        open={errors && form.agentes.length === 0} 
                        placement="top-end" 
                        arrow
                        componentsProps={{ tooltip: { sx: { bgcolor: red[700], fontWeight: 'bold' } }, arrow: { sx: { color: red[700] } } }}
                      >
                        <Box sx={{border: `1px solid 
                              ${errors && form.agentes.length === 0 ? red[700] : grey[300]}`, 
                              borderRadius: '8px'}}
                        >
                          <Box sx={boxstyle}>
                            {catalogos?.usuarios?.length > 0 ? catalogos.usuarios.map((u) => (
                              <Box
                                key={u.id}
                                sx={{
                                  ':hover': { bgcolor: grey[100] },
                                  display: 'flex',
                                  alignItems: 'center',
                                  height: '30px',
                                  transition: 'background-color 0.2s ease',
                                }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox 
                                      sx={{
                                        ml: 1, 
                                        color: grey[400], 
                                        '&.Mui-checked': { color: 'black' } 
                                      }} 
                                      size="small" 
                                      checked={form.agentes.includes(u.id)} 
                                      onChange={() => handleCheck(u.id)}
                                    />
                                  }
                                  label={
                                    <Typography variant="body2" sx={{ userSelect: 'none', fontWeight: 500 }}>
                                      {u.nombre_completo}
                                    </Typography>
                                  }
                                  sx={{ margin: 0, width: '100%' }}
                                />
                              </Box>
                            )) : (
                              <Box sx={{ p: 2, textAlign: 'center' }}>
                                <Typography variant="caption" sx={{ color: grey[500], fontStyle: 'italic' }}>
                                  No hay usuarios registrados.
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Box>
          
                      </Tooltip>
                    </FormGroup>

                  {/* NOTAS */}
                    <FormControl>
                      <Typography sx={{ mb: 0.5 }}>Notas</Typography>
                        <TextField  
                          variant='outlined'
                          size='small'
                          fullWidth 
                          name='notas'
                          multiline 
                          rows={1} 
                          sx={Inputstyle}  
                          value={form.notas}
                          placeholder='-'
                          onChange={(e) => setForm({...form, notas: e.target.value})} 
                          />
                    </FormControl>

                  {/* ESTADO */}
                    <FormControl>
                      <Typography sx={{ mb: 0.5 }}>Estado</Typography>
                          <ToggleButtonGroup
                            color="primary"
                            value={form.estado} // Ejemplo: 'programada'
                            exclusive // ESTO hace que funcione como un solo check (uno a la vez)
                            onChange={(e, nextValue) => {
                              if (nextValue !== null) { // Evita que se quede sin selección
                                setForm({ ...form, estado: nextValue });
                              }
                            }}
                            fullWidth
                            size="small"
                          >
                            <ToggleButton color='info' value="programada">Programada</ToggleButton>
                            <ToggleButton color='success' value="completada">Completada</ToggleButton>
                            <ToggleButton color='error' value="cancelada">Cancelada</ToggleButton>
                          </ToggleButtonGroup>
                    </FormControl>

                  {/* PRIORIDAD */}
                    <FormControl>
                      <Typography sx={{ mb: 0.5 }}>Prioridad</Typography>
                          <ToggleButtonGroup
                            color="primary"
                            value={form.prioridad} 
                            exclusive 
                            onChange={(e, nextValue) => {
                              if (nextValue !== null) {
                                setForm({ ...form, prioridad: nextValue });
                              }
                            }}
                            fullWidth
                            size="small"
                          >
                            <ToggleButton color='info' value="baja">Baja</ToggleButton>
                            <ToggleButton color='success' value="media">Media</ToggleButton>
                            <ToggleButton color='warning' value="alta">Alta</ToggleButton>
                            <ToggleButton color='error' value="inmediata">Inmediata</ToggleButton>
                          </ToggleButtonGroup>
                    </FormControl>

                  {/* BOTONES */}
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end', mt: 1 }}>
                    <Button 
                      variant="contained" 
                      sx={{width: { xs: '40%', sm: '20%' } , bgcolor: grey[100], color: 'black', textTransform: 'none', px: 3, '&:hover': { bgcolor: grey[200] } }}
                      onClick={() => setConfirmType('cancel')}
                    >
                      Cancelar
                    </Button>
                    <Button 
                      variant="contained" 
                      sx={{width: { xs: '55%', sm: '40%' } , bgcolor: 'black', color: 'white', textTransform: 'none', px: 3, '&:hover': { bgcolor: '#333' } }}
                      onClick={handleSaveClick}
                    >
                      Guardar Cambios
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
        </Box>
      </Modal>
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={2500} 
        onClose={() => setSnackbar({...snackbar, open: false})} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </LocalizationProvider>
  );
}